// Decisão pura de reset/preservação de xExtents na mudança de chave (#254).
// Extraída de useChartData para teste isolado — função pura, sem hook.

// Remount (ciclo destrutivo do fitWidth / rearranjo de painel FlexLayout) inicia
// prevKey como {periodicity:null, chartType:null}, o que dispara keyChanged
// falsamente. Detectar o remount para PRESERVAR o zoom/pan do usuário (#254).
export function isRemount(prevKey) {
  return prevKey.periodicity === null && prevKey.chartType === null;
}

export function keyChangedSince(prevKey, periodicity, chartType) {
  return prevKey.periodicity !== periodicity || prevKey.chartType !== chartType;
}

// Recalcula o viewport (xExtents = [start,end]) apenas em reset explícito ou
// mudança REAL de periodicidade/chartType — nunca num mero remount.
export function shouldResetViewportOnKey(
  prevKey,
  periodicity,
  chartType,
  resetTriggered,
) {
  if (resetTriggered) return true;
  return (
    keyChangedSince(prevKey, periodicity, chartType) && !isRemount(prevKey)
  );
}

// Decide o viewport a partir de um xExtents persistido (mesma chave/dado),
// validando-o contra os limites do dado atual. Extraída de useChartData para
// teste isolado. `bounds` = { minIndex, maxIndex, start, end,
// futureProjectionExtension } onde [start,end] é o viewport default flush-right.
export function resolveStoredXExtents(storedXExtents, bounds) {
  const { minIndex, maxIndex, start, end, futureProjectionExtension } = bounds;
  // Borda esquerda além da última barra: nada real na tela, extents
  // genuinamente inúteis → recalcula o default flush-right.
  if (storedXExtents[0] > maxIndex) {
    return [start, end];
  }
  // #360: panou ALÉM da barra mais antiga (chegou ao limite do histórico e não
  // há dado mais velho para carregar). Antes resetava para o flush-right, o que
  // SALTAVA o gráfico de volta para a barra mais recente. Em vez disso, clampa a
  // borda esquerda na primeira barra preservando a largura visível, mantendo o
  // usuário no dado mais antigo. A largura é limitada ao total de barras para
  // que um extents corrompido (muito negativo) não gere um viewport inválido.
  if (storedXExtents[0] < minIndex - 10) {
    const width = Math.min(
      storedXExtents[1] - storedXExtents[0],
      maxIndex - minIndex,
    );
    return [minIndex, minIndex + width];
  }
  // Issue #161 followup: viewport encostado na última barra real mas sem o
  // espaço da projeção Ichimoku → re-aplica a extensão para mantê-la visível.
  if (
    futureProjectionExtension > 0 &&
    storedXExtents[1] >= maxIndex - 1 &&
    storedXExtents[1] < maxIndex + futureProjectionExtension
  ) {
    return [storedXExtents[0], maxIndex + futureProjectionExtension];
  }
  // Pan/zoom deliberado — preserva.
  return storedXExtents;
}
